import { Component } from '@angular/core';

import { IRuleSummary, ISummaryMetrics } from '../../../../../../../../shared/interfaces/scan-summaries.interface';
import { $ruleSummary, $scanSummaries } from '../../../../../../../../shared/constants/scan-summaries';
import { IAuditRule } from '../../../../../../../../shared/interfaces/audit-rule.interface';
import { $auditRule } from '../../../../../../../../shared/constants/audit-rule';
import { $severity } from '../../../../../../../../shared/constants/accessibility';
import { AuditTypes } from '../../../../../../../../shared/constants/audit-types';
import { AbstractIssuesByStandardComponent } from '../abstract-issues-by-standard.component';

@Component({
  selector: 'app-issues-of-non-leveled-standard',
  templateUrl: '../abstract-issues-by-standard.component.html',
  styleUrls: ['../abstract-issues-by-standard.component.scss'],
  standalone: false,
})
export class IssuesOfNonLeveledStandardComponent extends AbstractIssuesByStandardComponent {
  public calculateTable(): void {
    const metrics: ISummaryMetrics = this.scanSummary[$scanSummaries.metrics];
    let rulesEvaluated: number = 0;
    let issuesDiscovered: number = 0;

    for (const ruleId of Object.getOwnPropertyNames(metrics)) {
      const ruleSummary: IRuleSummary = metrics[ruleId];
      const auditRule: IAuditRule | undefined = this.scanAudits[this.auditType]?.rules?.[ruleSummary.ruleName];
      const ruleSeverity = auditRule[$auditRule.severity];
      if (ruleSummary[$ruleSummary.triggered]) {
        if (ruleSeverity !== $severity.info) {
          if (this.auditType !== AuditTypes.accessibility_wave || ruleSummary[$ruleSummary.errors] > 0) {
            rulesEvaluated += 1;
          }
          issuesDiscovered += ruleSummary[$ruleSummary.errors];
        } else if (ruleSummary[$ruleSummary.errors] > 0) {
          rulesEvaluated += 1;
        }
      }
    }

    this.tableData = this.toTableData([
      {
        standard: `${this.includeStandard.standard} ${this.includeStandard.version}`,
        rulesEvaluated,
        issuesDiscovered,
      },
    ]);
  }
}
